<div id="layout-wrapper">
  <app-horizontaltopbar></app-horizontaltopbar>
  <div *ngIf="canDisplay()"  >
    <app-horizontalnavbar></app-horizontalnavbar>
   </div>
  
  <!-- ============================================================== -->
  <!-- Start right Content here -->
  <!-- ============================================================== -->
  <div class="main-content">
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>

  </div>

  <app-rightsidebar></app-rightsidebar>
</div>
<!-- END layout-wrapper -->
